// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1055":"f788ed17","6345":"5dd9d174","9133":"06901f31"}[chunkId] + ".chunk.css";
};